import * as React from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { useSession } from "./session";

export function RequireAuth() {
  const status = useSession((s) => s.status);
  const boot = useSession((s) => s.boot);
  const location = useLocation();

  React.useEffect(() => {
    if (status === "booting") void boot();
  }, [status, boot]);

  if (status === "booting") {
    return <div className="flex h-full items-center justify-center text-sm text-muted-foreground">Restoring session…</div>;
  }
  if (status === "anonymous") return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}
